export const getRandomEntries = (
  array: Array<string>,
  num: number,
  exceptions: Array<string> = [],
) => {
  const filteredArray = array.filter((item) => !exceptions.includes(item));

  const shuffled = filteredArray.sort(() => 0.5 - Math.random());

  return shuffled.slice(0, num);
};

export const shuffleArray = <T>(array: T[]): T[] => {
  const shuffledArray = [...array];

  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[randomIndex]] = [
      shuffledArray[randomIndex],
      shuffledArray[i],
    ];
  }

  return shuffledArray;
};
